import languagesDoc from "./languages.json";

export interface TopicLanguage {
  code: string;
  label: string;
}

/** Topic/search languages. Master list is `languages.json` (BFF loads the same file). */
export const topicLanguages: TopicLanguage[] = languagesDoc.languages;

export const defaultTopicLanguage = topicLanguages[0]?.code ?? "en";

export function isSupportedTopicLanguage(code: string | undefined | null): boolean {
  const c = (code ?? "").trim().toLowerCase();
  return topicLanguages.some((l) => l.code === c);
}

export function normalizeTopicLanguage(code: string | undefined | null): string {
  const c = (code ?? "").trim().toLowerCase();
  return isSupportedTopicLanguage(c) ? c : defaultTopicLanguage;
}

export function topicLanguageLabel(code: string | undefined | null): string {
  const normalized = normalizeTopicLanguage(code);
  return topicLanguages.find((l) => l.code === normalized)?.label ?? normalized.toUpperCase();
}
